import { Component } from '@angular/core';
import { RhythmService } from 'src/app/pages/rhythm/rhythm.service';

@Component({
  selector: 'app-nav-menu-sticky',
  templateUrl: './nav-menu-sticky.component.html',
  styleUrls: ['./nav-menu-sticky.component.scss']
})
export class NavMenuStickyComponent {


  public moving: boolean = false;
  public startPosition: number[] = [0, 0];
  public newPosition: number[] = [0, 0];

  constructor(
    public rhythmService: RhythmService
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {

  }

  public startMoving(event: MouseEvent) {
    this.moving = true;
    this.startPosition = [event.clientX, event.clientY];
  }

  public move(event: MouseEvent) {
    if (!this.moving) return;
    this.newPosition = [event.clientX - 50, event.clientY - 15];
    console.log(this.newPosition);
  }

  public stopMoving() {
    this.moving = false;
    this.newPosition = [0, this.newPosition[1]];
  }

  public toggleFullscreen(): void{
    if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen(); 
      }
    }
  }

  public pauseGame(): void {
    console.log('pauseGame')
    // button click sound trigger
    this.rhythmService.triggerSound('button-click');
    
    this.rhythmService.toggleMenu(!this.rhythmService.pausedGame);
  }

}
